"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProduct = void 0;
var _react = require("react");
var _context = require("../../context");
const useProduct = () => (0, _react.useContext)(_context.productContext);
exports.useProduct = useProduct;
